<template>
  <el-dialog
    :title="$t('admin.editRoles')"
    :visible="visible"
    @open="
      (v) => {
        init();
        $emit('update:visible', true);
      }
    "
    @close="(v) => $emit('update:visible', false)"
    width="80%"
  >
    <div class="createPermission">
      <!-- Create form start -->
      <el-row>
        <el-form :model="editForm" ref="form">
          <el-form-item :label="$t('admin.roleName')" prop="name">
            <el-input
              v-model="editForm.name"
              @input="sanitize($event)"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row>
        <el-tabs tab-position="left" style="display: block">
          <el-tab-pane v-for="category of categories" :key="category.name">
            <span slot="label">
              {{ $t(`home.${category.name}`)
              }}<el-checkbox
                style="margin-left: 10px"
                v-model="category.checked"
                @change="checkChange($event, category.name)"
                :indeterminate="category.indeterminated"
              ></el-checkbox
            ></span>
            <el-form :model="editForm" ref="form">
              <el-row>
                <el-col :span="18">{{ $t("admin.permissions") }}</el-col>
                <el-col :span="6">{{ $t("admin.let") }}</el-col>
              </el-row>
              <el-form-item>
                <el-row
                  v-for="permission of editForm.permissions.filter(
                    (x) => x.category == category.name
                  )"
                  :key="permission._id"
                >
                  <el-col :span="18">
                    {{ $t(`admin.${permission.name}`) }}
                  </el-col>
                  <el-col :span="6">
                    <el-switch
                      @change="setCategories()"
                      v-model="permission.checked"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                    >
                    </el-switch
                  ></el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-button
            style="float: right; margin-right: 20px"
            type="primary"
            @click="updateRoles()"
            >{{ $t("admin.update") }}</el-button
          >
        </el-col>
      </el-row>
      <!-- Create form Finish -->
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "AdminPermissionEdit",
  props: ["permission", "visible", "title"],
  events: ["edited"],
  components: {},
  data() {
    return {
      editForm: {
        _id: "",
        name: "",
        permissions: [],
      },
      categories: [],
    };
  },

  computed: {
    ...mapState("admin", ["roles", "permissions"]),
  },
  watch: {
    "permission.name": function () {
      this.editForm.name = this.permission.name;
      this.editForm._id = this.permission._id;
      this.editForm.permissions.forEach((x, i) => {
        if (this.permission.permissions.includes(x._id)) {
          this.editForm.permissions[i].checked = true;
        } else {
          this.editForm.permissions[i].checked = false;
        }
      });
    },
  },
  methods: {
    init() {
      this.editForm._id = this.permission._id;
      this.editForm.name = this.permission.name;
      this.editForm.permissions = this.permissions.data.map((x) => {
        return {
          ...x,
          checked: false,
        };
      });

      this.editForm.permissions.forEach((x, i) => {
        if (this.permission.permissions.includes(x._id)) {
          this.editForm.permissions[i].checked = true;
        } else {
          this.editForm.permissions[i].checked = false;
        }
      });
      this.setCategories();
    },
    setCategories() {
      this.categories = [
        ...new Set(this.permissions.data.map((x) => x.category)),
      ].map((category) => {
        let isAllChecked = this.editForm.permissions
          .filter((y) => y.category == category)
          .every((x) => x.checked);
        let anyChecked = this.editForm.permissions
          .filter((y) => y.category == category)
          .some((x) => x.checked);
        return {
          name: category,
          checked: isAllChecked,
          indeterminated: !isAllChecked && anyChecked,
        };
      });
    },
    checkChange(checked, category) {
      this.editForm.permissions
        .filter((x) => x.category == category)
        .forEach((x) => {
          x.checked = checked;
        });
    },

    ...mapActions("admin", ["updateRole"]),
    updateRoles() {
      let form = {
        _id: this.editForm._id,
        name: this.editForm.name,
        permissions: this.editForm.permissions
          .filter((x) => x.checked == true)
          .map((x) => {
            return x._id;
          }),
      };
      this.updateRole(form).then(() => this.$emit("edited"));
    },
    sanitize(name) {
      this.editForm.name = name
        .trim()
        .toUpperCase()
        .replace(/[^a-zA-Z _0-9]/g, "");
    },
  },
};
</script>
<style scoped>
.createPermission {
  flex: 1;
  padding: 20px;
}
p {
  margin-left: 30px;
}
.el-form-item__content label.country-selector__label {
  line-height: normal;
}

.el-form-item__content label.input-tel__label {
  line-height: normal;
}
</style>
<style scoped>
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}

.tabs {
  flex-basis: 80%;
  display: flex;
}
.component {
  padding: 10px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
}
.component-container {
  margin: 0 10px 20px 10px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  min-width: 300px;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  flex: 1 0 48%;
}
</style>